export default class CarouselNavigationElement extends HTMLElement {
  constructor() {
    super();
  }
}
customElements.define('carousel-navigation', CarouselNavigationElement);